document.addEventListener('livewire:navigated', () => {
    const path = window.location.pathname;
    const match = /^\/(food|drink)/.test(path);
    document.body.classList.toggle('food-page', match);
});
